import Tooltip from "@mui/material/Tooltip";
import moment from "moment";
import {Link} from "react-router";
import leftArrowImg from "../../../assets/images/left-arrow.svg";
import rightArrowImg from "../../../assets/images/right-arrow.svg";
import Down from "../../../assets/images/DownarrowB.svg";
import {DEFAULT_PROFILE_IMAGE} from "../../../app_url";
import PatientSearchWithFilters from "../../../components/PatientSearch/PatientSearchWithFilters";

const profileImageFor = (profile) =>
  profile?.pictureUrl || `/${DEFAULT_PROFILE_IMAGE}`;

const DEFAULT_BREADCRUMBS = [
  {label: "Appointments", to: "/doctor/appointments"},
  {label: "Appointment details"},
];

/**
 * Consultation page header with appointment navigation, patient search, and
 * doctor account actions. All mutations remain owned by the page controller.
 * `title`/`titleTo`/`breadcrumbs` let a sub-page (e.g. a full-page plugin)
 * link back to its appointment instead of the appointment list.
 */
export function ConsultationHeader({
  title = "All appointments",
  titleTo = "/doctor/appointments",
  breadcrumbs = DEFAULT_BREADCRUMBS,
  appointment,
  navigation,
  profile,
  isProfileOpen,
  onNavigate,
  onToggleProfile,
  onLogout,
}) {
  const hasAdjacentAppointment = navigation?.previousId || navigation?.nextId;

  return (
    <div className="RoxBox appointmentDetailsRoxBox">
      <div
        className="LftDoctorConsultationObservations"
        style={{cursor: "pointer"}}
      >
        <h3 onClick={() => onNavigate(titleTo)}>
          {title}
        </h3>
        <ul className="BreadCambs">
          {breadcrumbs.map((crumb) => (
            <li key={crumb.label}>
              {crumb.to ? <Link to={crumb.to}>{crumb.label}</Link> : crumb.label}
            </li>
          ))}
        </ul>
      </div>

      <div className="RghtDoctorConsultationObservations">
        <div className="RghtDoctorConsultationObservationsTop">
          {hasAdjacentAppointment ? (
            <div className="NextAppHolder">
              {navigation?.previousId ? (
                <Tooltip title="Previous appointment" placement="top">
                  <img
                    src={leftArrowImg}
                    className="ArrowIcon"
                    alt="Previous appointment"
                    onClick={() =>
                      onNavigate(
                        `/doctor/appointment-details/${navigation.previousId}`,
                      )
                    }
                  />
                </Tooltip>
              ) : null}

              <h4>
                {moment(appointment?.appointment_date).format("ddd D, YYYY")}, {appointment?.time}
              </h4>

              {navigation?.nextId ? (
                <Tooltip title="Next appointment" placement="top">
                  <img
                    src={rightArrowImg}
                    className="ArrowIcon"
                    alt="Next appointment"
                    onClick={() =>
                      onNavigate(
                        `/doctor/appointment-details/${navigation.nextId}`,
                      )
                    }
                  />
                </Tooltip>
              ) : null}
            </div>
          ) : null}

          <div className="rgtHeader">
            <div className="profile-menu">
              <div className="profile-header" onClick={onToggleProfile}>
                <img
                  src={profileImageFor(profile)}
                  className="profile-picture custom-skeleton"
                  alt="Profile"
                />
                <span className="profile-name">
                  {profile?.firstName} {profile?.lastName}
                </span>
                <button className="dropdown-toggle" type="button">
                  <img src={Down} className="Downarrow" alt="Open profile menu" />
                </button>
              </div>

              {isProfileOpen && (
                <div className="dropdown-content">
                  <Link to="/doctor/profile">My profile</Link>
                  <Link to="/doctor/account">My account</Link>
                  <Link to="/doctor/workspace-config">Workspace config</Link>
                  <Link to="/doctor/prescription-management">
                    Prescription management
                  </Link>
                  <Link to="/" onClick={onLogout}>
                    Logout
                  </Link>
                </div>
              )}
            </div>
            <PatientSearchWithFilters />
          </div>
        </div>
      </div>
    </div>
  );
}
